export default __webpack_public_path__ + "static/media/project-2.32aa73f8.png";